import { useMemo } from 'react';
import { isBuilderDepositSource } from 'utils/sourceTypeUtils';
import { ISourcesSummary, ISourceType } from 'views/ProFormaTable/types';

const useHasBuilderDepositSource = (
    sources: ISourcesSummary | undefined,
    sourceTypes: ISourceType[],
): boolean => useMemo(
    () => (sources?.sources ?? []).some(
        source => isBuilderDepositSource(source.sourceTypeId, sourceTypes),
    ),
    [sources, sourceTypes],
);

export default useHasBuilderDepositSource;
